import { useState, useCallback } from 'react';

/**
 * Custom hook for managing multiple modal states
 */
export const useModals = () => {
   const [modals, setModals] = useState({
      submit: false,
      manager: false,
      back: false,
      justification: false
   });

   const openModal = useCallback((modalName) => {
      setModals(prev => ({ ...prev, [modalName]: true }));
   }, []);

   const closeModal = useCallback((modalName) => {
      setModals(prev => ({ ...prev, [modalName]: false }));
   }, []);

   const toggleModal = useCallback((modalName) => {
      setModals(prev => ({ ...prev, [modalName]: !prev[modalName] }));
   }, []);

   return {
      modals,
      openModal,
      closeModal,
      toggleModal,
      // Convenience accessors
      isSubmitOpen: modals.submit,
      isManagerOpen: modals.manager,
      isBackOpen: modals.back,
      isJustificationOpen: modals.justification
   };
};
